import type { TFunction } from 'i18next';
import { string } from 'yup';

const make = (t: TFunction) =>
  string()
    .required(t('zipCodeIsRequired'))
    .test('zipCode', t('zipCodeMustBeValid'), (value = '') => {
      const united = /^\d{5}(-\d{4})?$/;
      const canadian = /^[a-zA-Z0-9]{3} [a-zA-Z0-9]{3}?$/;
      const australian =
        /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;

      return (
        united.test(value) || canadian.test(value) || australian.test(value)
      );
    });

export { make };
